import 'core-js/stable';
import Vue from 'vue';
import Acl from 'vue-browser-acl';
import Vuetify from 'vuetify';
import vuexI18n from 'vuex-i18n';
import { sync } from 'vuex-router-sync';
import { createPinia, PiniaVuePlugin } from 'pinia';
import App from '../App.vue';
import { aclRules } from '../config/acl-rules';
import { getLocale, getAllLocale } from '../translations/index';
import ScreenUrl from '../router/url';

// エコシステム読込
import store from '../store/index';
import router from '../router/index';

// 外部CSS読込 ※Vuetifyより先読必須
import 'normalize.css';
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import '../assets/css/roboto.css';

// Vuetify読込
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/es5/util/colors';

// エコシステム使用
(Vue.config as any).strict = process.env.NODE_ENV !== 'production';
Vue.use(Vuetify);
Vue.use(vuexI18n.plugin, store);

import VueDayjs from '../plugins/vue-dayjs';
Vue.use(VueDayjs);

sync(store, router);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// ロケール設定
const allLocale = getAllLocale();
allLocale.forEach(locale => {
    (Vue as any).i18n.add(locale.name, locale.data);
});
const browserLocale = getLocale();
(Vue as any).i18n.set(browserLocale.name);
(Vue as any).i18n.fallback(browserLocale.name);

// ACL設定
const user = {
    id: store.getters['auth/id'],
    authorities: store.getters['auth/authorities'],
};
Vue.use(Acl, user, aclRules, {
    router,
    failRoute: { path: ScreenUrl.TOP, replace: true },
});

// vuetify設定
const vuetifyOpts = {
    icons: {
        iconfont: 'mdi' as 'mdi',
    },
    theme: {
        themes: {
            light: {
                base: '#F5F5F5',
                primary: '#54546C',
                secondary: '#8283A7',
                accent: '#ECB13B',
            },
        },
    },
};

// Vueアプリ生成
new Vue({
    el: '#app',
    store,
    pinia,
    render: h => h(App),
    router,
    vuetify: new Vuetify(vuetifyOpts),
});
